import { AdminTermsModal } from '@dealstack/frontend/shared/components/TermsModals/AdminTermsModal';
import { InvestorTermsModal } from '@dealstack/frontend/shared/components/TermsModals/InvestorTermsModal';
import { PrivacyPolicyModal } from '@dealstack/frontend/shared/components/TermsModals/PrivacyPolicyModal';
import { useTranslationAuth } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Text } from '@mantine/core';
import { useState } from 'react';

interface Props {
	isInvestorApp?: boolean;
}

export const TermsAndPolicyV2 = ({ isInvestorApp }: Props) => {
	const tAuth = useTranslationAuth();

	const [isPrivacyModalOpened, setIsPrivacyModalOpened] = useState(false);
	const [isTermsModalOpened, setIsTermsModalOpened] = useState(false);

	const TermsModal = isInvestorApp ? InvestorTermsModal : AdminTermsModal;

	return (
		<div className="flex justify-center gap-2 absolute bottom-12 self-center -z-10">
			<Text
				size="B6Bold"
				onClick={() => setIsTermsModalOpened(true)}
				c="dark.8"
				style={{ cursor: 'pointer' }}
			>
				{tAuth('footer.user_terms')}
			</Text>
			<div className="rounded-full bg-[#D9D9D9] h-2.5 w-2.5 self-center"></div>
			<Text
				size="B6Bold"
				onClick={() => setIsPrivacyModalOpened(true)}
				c="dark.8"
				style={{ cursor: 'pointer' }}
			>
				{tAuth('footer.privacy_policy')}
			</Text>
			{isPrivacyModalOpened && (
				<PrivacyPolicyModal onClose={() => setIsPrivacyModalOpened(false)} />
			)}
			{isTermsModalOpened && <TermsModal onClose={() => setIsTermsModalOpened(false)} />}
		</div>
	);
};
